import { STALE_TIME_L } from "#app/http/ReactQueryProvider";
import { fetchCustomInputs } from "#modules/quoteRequestLines/infra/fetchCustomInputs.api";
import { queryKeys } from "#shared/queryKeys/queryKeys";

export const customInputsQuery = () => ({
  queryKey: queryKeys.customInputsCatalog.all,
  queryFn: () => fetchCustomInputs(),
  staleTime: STALE_TIME_L,
});
